var ajaxCall = {

    init: function (post_id) {
        var self = this;
        self.doAjaxRequest(post_id);
    },

    doAjaxRequest: function (post_id){
        var self     = this;
        var $parent  = $('#adherent');
        var $overlay = $('.overlay-load');

        $.ajax({
            url: ajax_login_object.ajaxurl,
            data:{
               'action' : 'do_ajax',
               'post_id': post_id
            },
            dataType: 'JSON',
            beforeSend: function(){
                $parent.removeClass('in');
                // show overlay load
                $overlay.addClass("is-visible");
            },
            success: function(data){
                self.drawAdherent(data);

                var stateObj = { Page: data.title, Url: data.slug };
                window.history.pushState(stateObj, data.title, '#'+data.slug);
                //window.history.pushState(stateObj, data.title, data.slug);
            },
            complete: function(){
                // hide overlay load
                $overlay.removeClass("is-visible");
            },
            error: function(errorThrown){
               console.log(errorThrown);
            }

        });

    },

}
